// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import HelpCircle from "@insite/mobius/Icons/HelpCircle";
import { xBaseTheme } from "@tps/XDL/types";
import { styledScrollbar } from "@tps/XDL/Utilities";
import { color } from "@tps/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            tooltipWrapper: css`
                line-height: 0;
            `,
            tooltipContainer: css`
                padding: 13px;
                font-size: 14px;
                line-height: 22px;
                max-width: 278px;
                color: ${color("text.main")};
                background-color: ${color("common.ui1")};
                border: 1px solid ${color("common.ui5")};
                text-align: left;
                border-radius: 6px;
                min-width: 140px;
                box-shadow: none;

                &[data-placement^="top"] > .tippy-arrow {
                    bottom: -10px;
                    &:before {
                        transform: rotate(45deg);
                    }
                }

                &[data-placement^="bottom"] > .tippy-arrow {
                    top: -10px;
                    &:before {
                        transform: rotate(-135deg);
                    }
                }

                &[data-placement^="left"] > .tippy-arrow {
                    right: -10px;
                    &:before {
                        transform: rotate(-45deg);
                    }
                }

                &[data-placement^="right"] > .tippy-arrow {
                    left: -10px;
                    &:before {
                        transform: rotate(135deg);
                    }
                }

                .tippy-arrow,
                .tippy-arrow::before {
                    position: absolute;
                    width: 20px;
                    height: 20px;
                    z-index: 1;
                    box-shadow: none;
                }

                .tippy-arrow::before {
                    content: "";
                    background: ${color("common.ui1")};
                    border-color: ${color("common.ui5")};
                    border-style: solid;
                    border-width: 0 1px 1px 0;
                }

                ${styledScrollbar(2)}
            `,
            tooltipBody: css`
                display: flex;
                flex-direction: column;
                flex: 0 0 auto;
            `,
            tooltipClickable: css`
                margin-left: 5px;
                margin-right: 5px;
            `,
        },
        iconProps: {
            src: HelpCircle,
            size: 16,
            color: "secondary",
            css: css``,
        },
        typographyProps: {
            size: 14,
            lineHeight: "22px",
            css: css`
                letter-spacing: 0;
                &:hover {
                    text-decoration: none;
                }
            `,
        },
        titleTypographyProps: {
            size: 16,
            lineHeight: "16px",
            css: css`
                letter-spacing: 0;
                margin-bottom: 8px;
                font-weight: 700;
                color: ${color("text.main")};
                &:hover {
                    text-decoration: none;
                }
            `,
        },
    },
} as xBaseTheme["tooltip"];
